import React from "react";
import {
  BsInstagram,
  BsWhatsapp,
  BsFacebook,
  BsTelegram,
  BsLinkedin,
  BsEnvelopeFill,
  BsCheckCircleFill
} from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const Channels = () => {
    const navigate = useNavigate();

  return (
  <div className="container-fluid px-4 py-4">

    {/* Header */}
    <div className="d-flex justify-content-between align-items-center mb-4">
      <h5 className="mb-0 fw-semibold">
        Connect with your social media
      </h5>
    {/* <button
  className="btn btn-outline-danger btn-sm"
  onClick={() => navigate("/channel/dashboard")}
>
  Go to Chat Dashboard
</button> */}

    </div>

    {/* Channels Grid */}
    <div className="row g-3">

      {/* WhatsApp — Active & clickable */}
      <div
        className="col-12 col-md-4 col-lg-4"
        style={{ cursor: "pointer" }}
        onClick={() => navigate("/channel/dashboard", { state: { platform: "whatsapp" } })}
      >
        <div className="card h-100 shadow-sm rounded-4">
          <div className="card-body d-flex flex-column">
            <BsWhatsapp size={36} color="#25D366" />
            <h6 className="fw-semibold mt-3">WhatsApp</h6>
            <p className="text-muted small mb-2">
              Connect WhatsApp to reply to customer messages directly from the dashboard.
            </p>
            <hr className="my-3" />
            <div className="d-flex align-items-center justify-content-between mt-auto">
              <span className="badge text-bg-success" style={{ fontSize: 11 }}>Active</span>
            </div>
          </div>
        </div>
      </div>

      {/* Instagram — Coming Soon, not clickable */}
      <div className="col-12 col-md-4 col-lg-4" style={{ cursor: "default" }}>
        <div className="card h-100 shadow-sm rounded-4" style={{ opacity: 0.7 }}>
          <div className="card-body d-flex flex-column">
            <BsInstagram size={36} color="#E1306C" />
            <h6 className="fw-semibold mt-3">Instagram</h6>
            <p className="text-muted small mb-2">
              Connect Instagram to reply to private messages and build strong brand...
            </p>
            <hr className="my-3" />
            <div className="d-flex align-items-center justify-content-between mt-auto">
              <span className="badge text-bg-warning" style={{ fontSize: 11 }}>Coming Soon</span>
            </div>
          </div>
        </div>
      </div>

      {/* Facebook — Coming Soon, not clickable */}
      <div className="col-12 col-md-4 col-lg-4" style={{ cursor: "default" }}>
        <div className="card h-100 shadow-sm rounded-4" style={{ opacity: 0.7 }}>
          <div className="card-body d-flex flex-column">
            <BsFacebook size={36} color="#1877F2" />
            <h6 className="fw-semibold mt-3">Facebook</h6>
            <p className="text-muted small mb-2">
              Connect Facebook to reply to private messages and build strong brand...
            </p>
            <hr className="my-3" />
            <div className="d-flex align-items-center justify-content-between mt-auto">
              <span className="badge text-bg-warning" style={{ fontSize: 11 }}>Coming Soon</span>
            </div>
          </div>
        </div>
      </div>

      {/* Telegram — Coming Soon, not clickable */}
      <div className="col-12 col-md-4 col-lg-4" style={{ cursor: "default" }}>
        <div className="card h-100 shadow-sm rounded-4" style={{ opacity: 0.7 }}>
          <div className="card-body d-flex flex-column">
            <BsTelegram size={36} color="#229ED9" />
            <h6 className="fw-semibold mt-3">Telegram</h6>
            <p className="text-muted small mb-2">
              Connect Telegram to reply to private messages and build strong brand...
            </p>
            <hr className="my-3" />
            <div className="d-flex align-items-center justify-content-between mt-auto">
              <span className="badge text-bg-warning" style={{ fontSize: 11 }}>Coming Soon</span>
            </div>
          </div>
        </div>
      </div>

      {/* LinkedIn — Coming Soon, not clickable */}
      <div className="col-12 col-md-4 col-lg-4" style={{ cursor: "default" }}>
        <div className="card h-100 shadow-sm rounded-4" style={{ opacity: 0.7 }}>
          <div className="card-body d-flex flex-column">
            <BsLinkedin size={36} color="#0A66C2" />
            <h6 className="fw-semibold mt-3">LinkedIn</h6>
            <p className="text-muted small mb-2">
              Connect LinkedIn to reply to private messages and build strong brand...
            </p>
            <hr className="my-3" />
            <div className="d-flex align-items-center justify-content-between mt-auto">
              <span className="badge text-bg-warning" style={{ fontSize: 11 }}>Coming Soon</span>
            </div>
          </div>
        </div>
      </div>

      {/* Gmail — Coming Soon, not clickable */}
      <div className="col-12 col-md-4 col-lg-4" style={{ cursor: "default" }}>
        <div className="card h-100 shadow-sm rounded-4" style={{ opacity: 0.7 }}>
          <div className="card-body d-flex flex-column">
            <BsEnvelopeFill size={36} color="#EA4335" />
            <h6 className="fw-semibold mt-3">Gmail</h6>
            <p className="text-muted small mb-2">
              Connect Gmail to reply to private messages and build strong brand...
            </p>
            <hr className="my-3" />
            <div className="d-flex align-items-center justify-content-between mt-auto">
              <span className="badge text-bg-warning" style={{ fontSize: 11 }}>Coming Soon</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
);

};

export default Channels;
 